// extracted by mini-css-extract-plugin
export default {"belowHeaderText":"auth__belowHeaderText__IuT02P","spinnerContainer":"auth__spinnerContainer__ElPFHX","paddedRow":"auth__paddedRow__vhtTfG"};